import { Services } from '@/infra/services';
import { type Response as CartShipmentsResponse } from '@/infra/services/checkout/cart/get-cart-shipments';
import { ZIP_CODE } from '@/utils/constants/cookies';
import { cookies } from '@/utils/cookies';
import { formatZipCode } from '@/utils/zip-code-utils/zip-code-utils';

export interface GetCartShipmentsProps {
  cartId: string;
}

export async function getCartShipments(
  props: Readonly<GetCartShipmentsProps>
): Promise<CartShipmentsResponse> {
  const { cartId } = props;

  const zipCodeCookie = cookies.client.get(ZIP_CODE);
  const rawZipCode = zipCodeCookie?.value || '';
  const zip_code = formatZipCode(rawZipCode);

  return await Services.Checkout.Cart.getCartShipments({
    cartId,
    zip_code,
  });
}
